import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Instagram } from 'lucide-react';
import { useCartStore } from '../store/useCartStore';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const {
    items,
    openCart
  } = useCartStore();
  const cartItemsCount = items.reduce((sum, item) => sum + item.quantity, 0);
  return <header className="fixed top-0 left-0 right-0 z-40 bg-brand-bg/85 backdrop-blur-md border-b border-black/5" data-id="element-31" data-mp="2ni7k3lt6vvn0">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center" data-id="element-32" data-mp="2wl8lj9740ykc">
        <Link to="/" className="text-2xl font-black tracking-tight flex items-center hover:opacity-80 transition-opacity" data-id="element-33" data-mp="2wivyihmhvy0f">
          <span className="text-brand-yellow font-script italic mr-1" data-id="element-34" data-mp="369qkrlzqqxlv">My</span>
          <span className="text-brand-blue" data-id="element-35" data-mp="3baxs5jxz1us0">Planer</span>
        </Link>

        <div className="flex items-center gap-4" data-id="element-36" data-mp="3fbq44ky8adrz">
          <a href="https://www.instagram.com/myplaner.ua/p/DXq4XE3jJA8/" target="_blank" rel="noopener noreferrer" className="hidden sm:flex items-center gap-2 text-brand-muted font-medium hover:text-brand-blue transition-colors duration-200 px-3 py-2 text-sm" data-id="element-37" data-mp="3fcjdzushhjec">
            <Instagram className="w-4 h-4" data-id="element-38" data-mp="2mmwyk7kzhoe7" />
            <span data-id="element-39" data-mp="2ho3l2f5p5xe1">@myplaner.ua</span>
          </a>

          <button onClick={openCart} className="relative flex items-center justify-center p-2.5 bg-brand-blue text-white hover:bg-brand-blueDark rounded-full transition-colors duration-200" data-id="element-40" data-mp="2hpeogdv8d34m">
            <ShoppingCart className="w-5 h-5" data-id="element-41" data-mp="35lj17qw5fnk8" />
            <AnimatePresence data-id="element-42" data-mp="35k7y7taj2ju6">
              {cartItemsCount > 0 && <motion.span initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} exit={{
              scale: 0
            }} className="absolute -top-1.5 -right-1.5 bg-brand-yellow text-brand-blueDark text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full border-2 border-brand-bg" data-id="element-43" data-mp="30mzgtux7ejtz">
                  {cartItemsCount}
                </motion.span>}
            </AnimatePresence>
          </button>
        </div>
      </div>
    </header>;
}